import React, { Component } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import LoginForm from './LoginForm';
import { doSetAuthenticatedUser } from '../../reducers/user';
import * as api from '../../webAPI/userService';
import localStorage from '../../utils/localStorage';

const LOCAL_STORAGE_KEY = `${require('Config').localStorageKey}:ids`;

class LoginFormContainer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			fields: {
				login: '',
				password: '',
				retainIDs: false
			},
			error: '',
			loading: false
		};

		this.handleFieldChange = this.handleFieldChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleError = this.handleError.bind(this);
		this.handleSuccess = this.handleSuccess.bind(this);
		this.saveIDsInLocalStorage = this.saveIDsInLocalStorage.bind(this);
		this.retrieveIDsFromLocalStorage = this.retrieveIDsFromLocalStorage.bind(
			this
		);
		this.setLoading = this.setLoading.bind(this);
	}

	componentDidMount() {
		const serializedIDs = this.retrieveIDsFromLocalStorage();
		if (serializedIDs) {
			const IDs = JSON.parse(serializedIDs);
			this.setState({
				fields: {
					...this.state.fields,
					login: IDs.login,
					password: IDs.password,
					retainIDs: true
				}
			});
		}
	}

	render() {
		const actions = {
			onFieldChange: this.handleFieldChange,
			onSubmit: this.handleSubmit
		};

		return <LoginForm {...this.state} {...actions} />;
	}

	handleFieldChange(value, name) {
		this.setState({
			fields: {
				...this.state.fields,
				[name]: value
			},
			error: ''
		});
	}

	handleSubmit() {
		const { projectId } = this.props.params;
		const { login, password } = this.state.fields;

		api
			.authenticate(login, password, projectId || null)
			.then(this.handleError, this.handleSuccess);

		this.setLoading(true);
	}

	handleError() {
		const error = 'Identifiant ou mot de passe incorrect';
		this.setState({
			error
		});

		this.setLoading(false);
	}

	handleSuccess(result) {
		const { user } = result;
		const { retainIDs } = this.state.fields;

		if (retainIDs) {
			this.saveIDsInLocalStorage();
		} else {
			this.removeIDsFromLocalStorage();
		}

		this.props.dispatch(doSetAuthenticatedUser(user));

		browserHistory.push('/app/project-v2');
	}

	saveIDsInLocalStorage() {
		const { login, password } = this.state.fields;
		const serializedIDs = JSON.stringify({
			login,
			password
		});

		localStorage.setItem(LOCAL_STORAGE_KEY, serializedIDs);
	}

	removeIDsFromLocalStorage() {
		localStorage.removeItem(LOCAL_STORAGE_KEY);
	}

	retrieveIDsFromLocalStorage() {
		const IDs = localStorage.getItem(LOCAL_STORAGE_KEY);
		return IDs;
	}

	setLoading(loading) {
		this.setState({ loading });
	}
}

export default withRouter(connect()(LoginFormContainer));



// WEBPACK FOOTER //
// ./src/js/Login/client/LoginFormContainer.js